import icon1 from "../assets/icons/icon1.svg";
import icon10 from "../assets/icons/icon10.svg";
import icon11 from "../assets/icons/icon11.svg";
import icon12 from "../assets/icons/icon12.svg";
import icon13 from "../assets/icons/icon13.svg";
import icon14 from "../assets/icons/icon14.svg";
import icon15 from "../assets/icons/icon15.svg";
import icon16 from "../assets/icons/icon16.svg";
import icon17 from "../assets/icons/icon17.svg";
import icon18 from "../assets/icons/icon18.svg";
import icon19 from "../assets/icons/icon19.svg";
import icon2 from "../assets/icons/icon2.svg";
import icon3 from "../assets/icons/icon3.svg";
import icon4 from "../assets/icons/icon4.svg";
import icon5 from "../assets/icons/icon5.svg";
import icon6 from "../assets/icons/icon6.svg";
import icon7 from "../assets/icons/icon7.svg";
import icon8 from "../assets/icons/icon8.svg";
import icon9 from "../assets/icons/icon9.svg";

export const targetAudienceData = {
  career_consult_page: [
    {
      icon_svg: icon1,
      text: "Хотите развития карьеры",
      smallText: "Но это кажется слишком сложной задачей",
    },
    {
      icon_svg: icon2,
      text: "Планируете поиск работы",
      smallText: "За рубежом, удаленно или внутри страны",
    },
    {
      icon_svg: icon3,
      text: "Оцениваете спрос рынка",
      smallText: "Хотите минимизировать риски и сделать правильный выбор",
    },
  ],
  cv_ready_page: [
    {
      icon_svg: icon4,
      text: "Нет сил на резюме",
      smallText: "Апатия и ступор при мысли о резюме",
    },
    {
      icon_svg: icon5,
      text: "Поиск новой работы",
      smallText: "Хотите выгодно подчеркнуть сильные стороны",
    },
    {
      icon_svg: icon6,
      text: "Оффер за рубежом",
      smallText: "Не умеете заявить о себе на мировой арене",
    },
  ],
  search_support_page: [
    {
      icon_svg: icon2,
      text: "Не знаете как искать работу",
      smallText: "Не умеете продавать себя на современном рынке труда",
    },
    {
      icon_svg: icon7,
      text: "Не уверены в себе",
      smallText: "Синдром самозванца и отсутствие внутреннего профессионала внутри",
    },
    {
      icon_svg: icon6,
      text: "Оффер за рубежом",
      smallText: "Не умеете себя продать на мировой арене",
    },
  ],
  probation_support_page: [
    {
      icon_svg: icon8,
      text: "Важно показать результат",
      smallText: "Нет времени на погружение, нужен результат",
    },
    {
      icon_svg: icon7,
      text: "Не уверены в себе",
      smallText: "Синдром самозванца и отсутствие внутреннего профессионала внутри",
    },
    {
      icon_svg: icon9,
      text: "Стремитесь к росту",
      smallText: "Создание прочных связей с первого рабочего дня",
    },
  ],
  vacancies_page: [
    {
      icon_svg: icon2,
      text: "Нет свободного времени на поиск",
      smallText: "Мы забираем до 60% нагрузки внутри поиска",
    },
    {
      icon_svg: icon7,
      text: "Не знаете как искать и как откликаться",
      smallText: "1000+ источников поиска, актуальные навыки отклика",
    },
    {
      icon_svg: icon6,
      text: "Привыкли делегировать рутину",
      smallText: "И сконцентрироваться на главном",
    },
  ],
  talkitout_page: [
    {
      icon_svg: icon10,
      text: "Испытываете тревогу",
      smallText: "При мыслях о работе непонятная тревога, и не можете понять почему",
    },
    {
      icon_svg: icon11,
      text: "Hе видите будущего карьеры",
      smallText: "Нет понимания куда двигаться в профессиональном развитии",
    },
    {
      icon_svg: icon12,
      text: "Ощущаете как выгораете",
      smallText: "Работа больше не приносит радости и удовлетворения",
    },
  ],
  it_hiring_page: [
    {
      icon_svg: icon13,
      text: "Создаете ИТ отдел с 0",
      smallText: "Нет понимания как нанять ИТ специалистов",
    },
    {
      icon_svg: icon14,
      text: "Нужно было еще вчера",
      smallText: "Горячая позиция, которая не закрывается",
    },
    {
      icon_svg: icon15,
      text: "Делегируете задачи",
      smallText: "И доверяете профессионалам в ИТ подборе",
    },
  ],
  it_training_page: [
    {
      icon_svg: icon6,
      text: "Удаленная работа",
      smallText: "Для тех, кто хочет работать удаленно",
    },
    {
      icon_svg: icon2,
      text: "Перейти в ИТ индустрию",
      smallText: "Стать частью мирового Tech сообщества",
    },
    {
      icon_svg: icon16,
      text: "Много зарабатывать",
      smallText: "Давай вместе зарабатывать как разработчик",
    },
  ],
  linkedin_boost_page: [
    {
      icon_svg: icon17,
      text: "Топ-менеджерам",
      smallText: "LinkedIn нужен для роста нетворка и профессиональной видимости",
    },
    {
      icon_svg: icon18,
      text: "Релокантам",
      smallText: "Linkedin  топ-1 платформа для нахождения международного оффера",
    },
    {
      icon_svg: icon19,
      text: "Фаундерам",
      smallText: "Важно усиливать личный бренд, выстраивать доверие к бизнесу",
    },
  ]
}
